export const CONTENT_BRANCH_MAPPING = {
	dog: 'hund',
	boat: 'boot',
	horse: 'pferd',
	sprenger: 'sprenger'
};

export const BRANCH_CONTENT_MAPPING = Object.fromEntries(
	Object.entries(CONTENT_BRANCH_MAPPING).map(([key, value]) => [value, key])
);
